import { api } from './api'

export const chargeCCManual = (booking) => api.get(`/charge/${booking.customerId}/${booking.id}`)
export const chargeCCManualCustomer = (data) => api.post('/charge/manual-charge', data)
